import {
  createContext,
  useState,
  type ReactNode,
  type Dispatch,
  type SetStateAction,
} from "react";
export type PermissionListState = {
  query: string;
  filter: "all" | "allowed" | "denied";
};
export const PermissionListContext = createContext<{
  value: PermissionListState;
  setValue: Dispatch<SetStateAction<PermissionListState>>;
} | null>(null);
export function SettingsNavigationState({ children }: { children: ReactNode }) {
  const [value, setValue] = useState<PermissionListState>({
    query: "",
    filter: "all",
  });
  return (
    <PermissionListContext.Provider value={{ value, setValue }}>
      {children}
    </PermissionListContext.Provider>
  );
}
